import { DataProvider, Identifier, Translate } from "react-admin";
import { BusinessError, checkErrors } from "../../common/components/utils/error";
import { findAndAction, findOne, sendMail, update } from "../common/common";
import { createTasks } from "../task/actions";

export const validateLot = ({ startDate, endDate }) => {
    const errors = {};
    if (startDate > endDate) {
        errors["startDate"] = "resources.validate.coherenceDate";
        errors["endDate"] = "resources.validate.coherenceDate";
    }
    return errors;
};

export const startLot = (dataProvider: DataProvider, refresh, translate: Translate, notify, lot: any) => async (e) => {
    e.stopPropagation();
    if (typeof lot === "number" || typeof lot === "string") {
        lot = await findOne(dataProvider, "lot", { id: lot });
    }
    const errors = [];
    const project = await findOne(dataProvider, "project", { id: lot.projectId });
    if (!project || project.status !== "enabled") {
        errors.push(new BusinessError("resources.lot.validate.projectEnabled"));
    }
    const lotId = lot.id;
    const firstUnit = await findOne(dataProvider, "production_unit", { lotId });
    if (!firstUnit) {
        errors.push(new BusinessError("resources.lot.validate.empty"));
    }
    const data = { tracking: "inProgress" };
    if (checkErrors(errors, notify, translate)) {
        const projectId = lot.projectId
        const project = await findOne(dataProvider, "project", { id: projectId });
        let quantityTotal = 0;
        const ids: Identifier[] = [];
        await findAndAction(dataProvider, "production_unit", { lotId }, ({ id, quantity }) => {
            ids.push(id);
            quantityTotal += quantity;
        });
        await dataProvider.update("lot", {
            id: lotId,
            data,
            previousData: lot
        });
        // We need update all project
        await findAndAction(dataProvider, "task", { subprojectLotId: lotId, taskStatus: "available" }, (previousData) => {
            update(dataProvider, "task", previousData.id, { taskStatus: "assigned" }, previousData)
        });
        await dataProvider.updateMany("production_unit", {
            ids,
            data
        });
        await dataProvider.updateMany("production_unit", {
            ids,
            data
        });
        await createTasks(dataProvider, lot, project);
        await findAndAction(dataProvider, "manager_starting", { projectId }, (result) => {
            sendMail("lot/started", {
                to: result.email,
                fullname: result.fullname,
                stageName: result.stageName,
                lotName: lot.name,
                projectName: project.name,
                unitProd: project.unitProd,
                unitMeasure: project.unitMeasure,
                nb: ids.length,
                quantityTotal
            });
        });
        refresh();
    }
};


export interface Lot {
    id?: Identifier;
    name: string;
    startDate: Date;
    endDate: Date;
    tracking: string;
    projectId: Identifier
};

export const getLot = (dataProvider: DataProvider, lotId: Identifier): Promise<Lot> => {
    return findOne(dataProvider, "lot", { id: lotId });
};